const Login = () => {
  return (
    <div>
      CLTP login placeholder
    </div>
  );
};

export default Login;
